/**
 * Set a meta header theme for mobile
 * @param theme color string as "#FEFEFE" (default)
 */
export const toggleTheme = (theme: "default" | "light-grey" | "pastel-purple") => {
    const colors = {
        default: "#FEFEFE", // light
        "light-grey": "#f6f6f6",
        "pastel-purple": "#f6f4fc",
    };
    const headMeta = document.querySelector("meta[name='theme-color']") as HTMLElement;
    headMeta.setAttribute("content", colors[theme]);
};
